import {Button as ButtonUI} from '@/components/ui/button';
import { ReactNode } from 'react';

interface IButtonProps{
    label?: string;
    children?: ReactNode;
    variant: 'primary' | 'secondary' | 'linkPrimary' | 'linkSecondary',
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    size?: 'default' | 'sm' | 'lg' | 'icon';
}

const Button = ({label, onClick, variant, className, children, size}: IButtonProps) => {
    return(
        <ButtonUI size={size} variant={variant} onClick={onClick} className={className}>
            {label ? label : children}
        </ButtonUI>
    )
}

export {Button};